import { jsx } from 'react/jsx-runtime';
import { MenuChipButton } from './Menu.ChipButton/Menu.ChipButton.es.js';
import { MenuProvider } from './Menu.Context/provider.es.js';
import { MenuV2Core } from './Menu.Core/Menu.Core.es.js';
import { MenuIconButton } from './Menu.IconButton/Menu.IconButton.es.js';
import { MenuItem as MenuItem$1 } from './Menu.Item/Menu.Item.es.js';
import { MenuItemLink } from './Menu.Item/Menu.Item.Link.es.js';
import { MenuOptions } from './Menu.Options/Menu.Options.es.js';
import { MenuTrigger } from './Menu.Trigger/Menu.Trigger.es.js';

const MenuItem = MenuItem$1;
/**
 * Menu V2.
 */ const MenuV2 = (props)=>{
    return jsx(MenuProvider, {
        disabled: props.disabled,
        inputLoading: props.inputLoading,
        menuLoading: props.menuLoading,
        open: false,
        role: props.role,
        children: jsx(MenuV2Core, {
            ...props
        })
    });
};
MenuV2.displayName = 'MenuV2';
MenuV2.Options = MenuOptions;
MenuV2.Item = MenuItem;
MenuItem.Link = MenuItemLink;
MenuV2.IconButton = MenuIconButton;
MenuV2.ChipButton = MenuChipButton;
MenuV2.Trigger = MenuTrigger;

export { MenuItem, MenuV2, MenuV2 as default };
//# sourceMappingURL=MenuV2.es.js.map
